import {
    GET_PERMISSIONS_LIST,
    GET_PERMISSIONS_LIST_SUCCESS,
    GET_PERMISSIONS_LIST_FAIL,
    ADD_NEW_PERMISSION,
    ADD_NEW_PERMISSION_SUCCESS,
    ADD_NEW_PERMISSION_FAIL,
    UPDATE_PERMISSION,
    UPDATE_PERMISSION_SUCCESS,
    UPDATE_PERMISSION_FAIL,
    DELETE_PERMISSION,
    DELETE_PERMISSION_SUCCESS,
    DELETE_PERMISSION_FAIL,
} from "./actionTypes"

export const getPermissionsList = () => ({
    type: GET_PERMISSIONS_LIST,
})

export const getPermissionsListSuccess = (permissions) => ({
    type: GET_PERMISSIONS_LIST_SUCCESS,
    payload: permissions,
})

export const getPermissionsListFail = (error) => ({
    type: GET_PERMISSIONS_LIST_FAIL,
    payload: error,
})

export const addNewPermission = (permission) => ({
    type: ADD_NEW_PERMISSION,
    payload: permission,
})

export const addNewPermissionSuccess = (permission) => ({
    type: ADD_NEW_PERMISSION_SUCCESS,
    payload: permission,
})

export const addNewPermissionFail = (error) => ({
    type: ADD_NEW_PERMISSION_FAIL,
    payload: error,
})

export const updatePermission = (permission) => ({
    type: UPDATE_PERMISSION,
    payload: permission,
})

export const updatePermissionSuccess = (permission) => ({
    type: UPDATE_PERMISSION_SUCCESS,
    payload: permission,
})

export const updatePermissionFail = (error) => ({
    type: UPDATE_PERMISSION_FAIL,
    payload: error,
})

export const deletePermission = (id) => ({
    type: DELETE_PERMISSION,
    payload: id,
})

export const deletePermissionSuccess = (id) => ({
    type: DELETE_PERMISSION_SUCCESS,
    payload: id,
})

export const deletePermissionFail = (error) => ({
    type: DELETE_PERMISSION_FAIL,
    payload: error,
})
